import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ScrollToTop2 from "react-scroll-to-top";

import ScrollToTop from "./../layouts/ScrollToTop";
import LoaderData from "./../layouts/LoaderData";

const Home = lazy(() => import("./Home"));
const About = lazy(() => import("./About"));
const Partners = lazy(() => import("./Partners"));
const ContactUs = lazy(() => import("./ContactUs"));
const ErrorPage = lazy(() => import("./ErrorPage"));
const Error500Page = lazy(() => import("./500ErrorPage"));
const ResearchersList = lazy(() => import("./People/ResearchersList"));
const PhdList = lazy(() => import("./People/PhdList"));
const StaffList = lazy(() => import("./People/StaffList"));
const PeopleDetails = lazy(() => import("./People/PeopleDetails"));
const Certificates = lazy(() => import("./Training/Certificates"));
const CertificateDetails = lazy(() => import("./Training/CertificateDetails"));
const Masters = lazy(() => import("./Training/Masters"));
const MasterDetails = lazy(() => import("./Training/MasterDetails"));
const Doctoral = lazy(() => import("./Training/Doctoral"));
const Bachelor = lazy(() => import("./Training/Bachelor"));
const LaboratoryList = lazy(() => import("./Research/Laboratories/LaboratoryList"));
const LaboratoryDetails = lazy(() => import("./Research/Laboratories/LaboratoryDetails"));
const ProjectList = lazy(() => import("./Research/Projects/ProjectList"));
const ProjectDetails = lazy(() => import("./Research/Projects/ProjectDetails"));
const AxeList = lazy(() => import("./Research/Axes/AxeList"));
const AxeDetails = lazy(() => import("./Research/Axes/AxeDetails"));
const AxethemeDetails1 = lazy(() => import("./Research/Axes/AxethemeDetails1"));
const NewsList = lazy(() => import("./News/NewsList"));
const NewsDetails = lazy(() => import("./News/NewsDetails"));
const EventList = lazy(() => import("./Events/EventList"));
const EventDetails = lazy(() => import("./Events/EventDetails"));
const Publications = lazy(() => import("./Research/Publications/Publications"));
const Opportunities = lazy(() => import("./Opportunities"));
const OpportunityDetails = lazy(() => import("./OpportunityDetails"));

function Index() {
  return (
    <BrowserRouter basename="/">
      <div className="page-wraper">
        <Suspense fallback={<LoaderData />}>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/about" exact component={About} />
          <Route path="/partners" exact component={Partners} />
          <Route
            path="/research/laboratories"
            exact
            component={LaboratoryList}
          />
          <Route
            path="/research/laboratories/details/:slug"
            exact
            component={LaboratoryDetails}
          />
          <Route path="/news" exact component={NewsList} />
          <Route path="/training/certificates" exact component={Certificates} />
          <Route path="/news/:slug" exact component={NewsDetails} />
          <Route path="/events/:category" exact component={EventList} />
          <Route
            path="/events/:category/:link"
            exact
            component={EventDetails}
          />

          <Route path="/research/projects" exact component={ProjectList} />
          <Route
            path="/research/projects/:slug"
            exact
            component={ProjectDetails}
          />
          <Route path="/research/axes" exact component={AxeList} />
          {/* Dynamic route for axe details using axeId */}
          <Route
            path="/research/axes/:axeId"
            exact
            component={AxeDetails}
          />
          {/* Dynamic route for theme details using themeId */}
          <Route
            path="/research/themes/:themeId"
            exact
            component={AxethemeDetails1}
          />
          
          <Route path="/research/publications" exact component={Publications} />
          <Route path="/opportunities" exact component={Opportunities} />
          <Route path="/opportunities/:slug" exact component={OpportunityDetails} />
          <Route path="/contact" exact component={ContactUs} />
          <Route path="/error/404" exact component={ErrorPage} />
          <Route path="/error/500" exact component={Error500Page} />
          <Route path="/people/researchers" exact component={ResearchersList} />
          <Route path="/people/details/:id" exact component={PeopleDetails} />
          <Route path="/people/phd-students" exact component={PhdList} />
          <Route
            path="/people/administrative-staff"
            exact
            component={StaffList}
          />
          <Route path="/training/masters" exact component={Masters} />
          <Route path="/training/masters/:slug" exact component={MasterDetails} />
          <Route path="/training/doctoral" exact component={Doctoral} />
          <Route path="/training/doctoral/:slug" exact component={MasterDetails} />
          <Route path="/training/bachelor" exact component={Bachelor} />
          <Route path="/training/bachelor/:slug" exact component={MasterDetails} />
          <Route path="/certificates/:slug" exact component={CertificateDetails} />

          {/* Catch-all route for unmatched paths */}
          <Route component={ErrorPage} />
        </Switch>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}

export default Index;
